"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXTERNAL_INFO_KEY = void 0;
var EXTERNAL_INFO_KEY;
(function (EXTERNAL_INFO_KEY) {
    //comet
    EXTERNAL_INFO_KEY["COMET_MISSION_ID"] = "COMET_MISSION_ID";
    EXTERNAL_INFO_KEY["COMET_MISSION_NUMBER"] = "COMET_MISSION_NUMBER";
    EXTERNAL_INFO_KEY["COMET_CASE_NUMBER"] = "COMET_CASE_NUMBER";
    EXTERNAL_INFO_KEY["COMET_CLIENT_FIRST_NAME"] = "COMET_CLIENT_FIRST_NAME";
    EXTERNAL_INFO_KEY["COMET_CLIENT_LAST_NAME"] = "COMET_CLIENT_LAST_NAME";
    EXTERNAL_INFO_KEY["COMET_NB_PASSENGER"] = "COMET_NB_PASSENGER";
    EXTERNAL_INFO_KEY["COMET_CLIENT_PHONE_NUMBER"] = "COMET_CLIENT_PHONE_NUMBER";
    EXTERNAL_INFO_KEY["COMET_CLIENT_EMAIL"] = "COMET_CLIENT_EMAIL";
    EXTERNAL_INFO_KEY["COMET_NUMBER_PASSENGERS"] = "COMET_NUMBER_PASSENGERS";
    //KARHOO
    EXTERNAL_INFO_KEY["KARHOO_SOURCE"] = "KARHOO_SOURCE";
    EXTERNAL_INFO_KEY["KARHOO_ID"] = "KARHOO_ID";
    //sncf
    EXTERNAL_INFO_KEY["CTR"] = "CTR";
    EXTERNAL_INFO_KEY["BUPO"] = "BUPO";
    EXTERNAL_INFO_KEY["ORDER_ENTITY"] = "ORDER_ENTITY";
    EXTERNAL_INFO_KEY["ORDER_ENTITY_ID"] = "ORDER_ENTITY_ID";
    EXTERNAL_INFO_KEY["ORDER_ENTITY_ETS"] = "ORDER_ENTITY_ETS";
    EXTERNAL_INFO_KEY["INVOICE_ENTITY"] = "INVOICE_ENTITY";
    EXTERNAL_INFO_KEY["INVOICE_ENTITY_ID"] = "INVOICE_ENTITY_ID";
    EXTERNAL_INFO_KEY["INVOICE_ENTITY_ETS"] = "INVOICE_ENTITY_ETS";
    EXTERNAL_INFO_KEY["JS_NUM"] = "JS_NUM";
    EXTERNAL_INFO_KEY["NUM_CP"] = "NUM_CP";
    EXTERNAL_INFO_KEY["ETS"] = "ETS";
    //general
    EXTERNAL_INFO_KEY["INVOICE_MENTION"] = "INVOICE_MENTION";
    EXTERNAL_INFO_KEY["SECOND_INVOICE_MENTION"] = "SECOND_INVOICE_MENTION";
    EXTERNAL_INFO_KEY["THIRD_INVOICE_MENTION"] = "THIRD_INVOICE_MENTION";
    EXTERNAL_INFO_KEY["EXTERNAL_ID"] = "EXTERNAL_ID";
    EXTERNAL_INFO_KEY["EXTERNAL_PARTNER_ID"] = "EXTERNAL_PARTNER_ID";
    EXTERNAL_INFO_KEY["THIRD_PART_ID"] = "THIRD_PART_ID";
    EXTERNAL_INFO_KEY["COMMENT"] = "COMMENT";
    EXTERNAL_INFO_KEY["NB_PASSENGERS"] = "NB_PASSENGERS";
    EXTERNAL_INFO_KEY["NB_BAGGAGES"] = "NB_BAGGAGES";
})(EXTERNAL_INFO_KEY = exports.EXTERNAL_INFO_KEY || (exports.EXTERNAL_INFO_KEY = {}));
